import ExtendedOrderDetailContainer from '@/components/OrdersModule/OrderDetail/ExtendedOrderDetailContainer'
import MapPanel from '@/features/orders/components/MapPanel'
import Tabs from '@/features/orders/components/Tabs'
import { useCompactMapController } from '@/features/orders/hooks/useCompactMapController'
import { useOrderDetailNavigation } from '@/features/orders/hooks/useOrderDetailNavigation'
import { useScreenLayout } from '@/hooks/screen'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

const Layout: FC = () => {
    const screenLayout = useScreenLayout()
    const compact = screenLayout === 'compact'
    const compactMap = useCompactMapController()
    const navigateToOrderDetail = useOrderDetailNavigation()

    return (
        <View style={[styles.container, !compact && styles.extended]}>
            <Tabs onMapOpen={compactMap.open} />
            {/* Keep the map at the same position in the tree across layout changes. */}
            <MapPanel
                layout={screenLayout}
                visible={!compact || compactMap.isOpen}
                onClose={compactMap.close}
                onOrderPress={compact ? compactMap.openOrder : navigateToOrderDetail}
            />
            {!compact && <ExtendedOrderDetailContainer />}
        </View>
    )
}

const styles = StyleSheet.create({
    container: { flex: 1 },
    extended: { flexDirection: 'row' },
})

export default Layout
